import Api from './axiosInstance'
import { API_SMART_OOS } from 'utils/constants'

// To Upload a smart oss file in server
const uploadFileOos = async (data: any) => {
  return Api.post({
    url: API_SMART_OOS.UPLOAD,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

type Common = {
  limit: number
  page: number
}

// To Upload a smart oss file in server
const getSmartOosData = async ({ limit, page }: Common) => {
  return Api.get({
    url: `${API_SMART_OOS.SMART_OOS}?limit=${limit}&page=${page}`,
  })
}

export { uploadFileOos, getSmartOosData }
